import { Alert, AlertTitle, Snackbar } from "@mui/material";
import { RequestStatusEnum } from "../../helper/constant";

export type ResponseModalContext = {
  status?: RequestStatusEnum;
  isOpen?: boolean;
  onClose?: () => void;
};
export default function ResponseModal(props: ResponseModalContext) {
  const vertical = "top";
  const horizontal = "center";
  return props.status == RequestStatusEnum.FAILURE ? (
    <Snackbar
      aria-label="action-response"
      open={props.isOpen}
      autoHideDuration={14000}
      onClose={props.onClose}
      key={vertical + horizontal}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert
        onClose={props.onClose}
        variant="filled"
        severity="error"
        sx={{ width: "56.5%" }}
      >
        <AlertTitle> Oops!</AlertTitle>
        Your input was not captured because we ran into a problem. Please try
        again in a couple of minutes.
      </Alert>
    </Snackbar>
  ) : (
    <Snackbar
      aria-label="action-response"
      open={props.isOpen}
      autoHideDuration={14000}
      onClose={props.onClose}
      key={vertical + horizontal}
      anchorOrigin={{ vertical, horizontal }}
    >
      <Alert onClose={props.onClose} variant="filled" severity="success">
        <AlertTitle> Success!</AlertTitle>
        Your deferment has been captured successfully.
      </Alert>
    </Snackbar>
  );
}
